import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Layout.css';

export default function Layout({ children }) {
  const { agent, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => { signOut(); navigate('/login'); };

  return (
    <div className="layout">
      <nav className="navbar">
        <div className="navbar-inner">
          <div className="navbar-brand">
            {agent?.logo_url
              ? <img src={agent.logo_url} alt="logo" className="navbar-logo"/>
              : <span className="navbar-name">PAR Report</span>
            }
          </div>
          <div className="navbar-links">
            <NavLink to="/dashboard" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Dashboard</NavLink>
            <NavLink to="/reports/new" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>New Report</NavLink>
            <NavLink to="/credits" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Buy Credits</NavLink>
            <NavLink to="/settings" className={({isActive}) => isActive ? 'nav-link active' : 'nav-link'}>Settings</NavLink>
          </div>
          <div className="navbar-right">
            <div className="credit-pill">
              <span className="credit-count">{agent?.credits ?? 0}</span>
              <span className="credit-label">credits</span>
            </div>
            <button className="btn btn-ghost btn-sm" onClick={handleSignOut}>Sign out</button>
          </div>
        </div>
      </nav>
      <main className="main-content">{children}</main>
    </div>
  );
}
